<nz-alert nzType="error" *ngFor="let message of errorMessage" [nzMessage]="message" nzShowIcon></nz-alert>
